#@export GliveBooking.Presenters.DatePicker

class GliveBooking.Presenters.DatePicker extends BookingV2.Presenters.DatePicker

  module: 'glive-booking'

  toHash: ->
    hash = BookingV2.Presenters.DatePicker.prototype.toHash.apply(this, arguments)
    hash.isTouch = @collection.meta('isTouch')
    hash
